import http from "../http-common";
import axios from "axios";


class ConvoService {
  getConvos = (type = "") => (type ? http.get(`/convos?type=${type}`) : http.get("/convos"));

  getTodayConvos = ()=>{http.get(`/convos/today`)};

  getConvo = (convo_id) => http.get(`/convos/${convo_id}`);

  addConvo = (data) => http.post("/convos", data);

  addMessage = (convo_id, message) => {axios.post(process.env.VUE_APP_API_URL +`/api/convos/${convo_id}/messages`, {message},{
  withCredentials: true
});}

  addGeneralMessage = (convo_id, formData) => {return axios.post(process.env.VUE_APP_API_URL + `/api/convos/${convo_id}/generalmessage`,formData,
  { withCredentials: true });
};


  getMessages = (convo_id) => http.get(`/convos/${convo_id}/messages`);

  updateConvoStatus = (convo_id, data) => http.put(`/convos/${convo_id}/status`,data);

  addReminder = (convo_id, date) => http.post(`/convos/${convo_id}/reminders`, { date });

  // convo_reminder_id: optional — targets a specific reminder row (e.g. someone
  // else's) instead of the caller's own, per reminderWhere in convo.controller.js
  updateReminder = (convo_id, date, convo_reminder_id) => http.put(`/convos/${convo_id}/reminders`, { date, convo_reminder_id });

  deleteReminder = (convo_id, convo_reminder_id) => http.delete(`/convos/${convo_id}/reminders`, { data: { convo_reminder_id } });

  getParticipants = (convo_id) => http.get(`/convos/${convo_id}/participants`);

  addParticipant = (convo_id) => http.post(`/convos/${convo_id}/participants`);

  updateLastReadTime = (convo_id) => http.put(`/convos/${convo_id}/participants`);

  deleteParticipant = (convo_id) => http.delete(`/convos/${convo_id}/participants`);

  updateMentionStatus = (convo_id, message_id, params) =>
    http.put(`/convos/${convo_id}/messages/${message_id}/mentions`, params);

  // INTERNAL CONVOS
  getClientInternalConvos = (contact_id) => http.get(`convos/internal/all/${contact_id}`);

  getClientClosedInternalConvos = (contact_id) => http.get(`convos/internal/closed/${contact_id}`);

  getClientInternalConvosToday = () => http.get(`convos/internal/allToday`);

  getClientInternalConvosLater = () => http.get(`convos/internal/allLater`);

  createInternalConvo = (data) => http.post("convos/internal", data);
  
  

  getInternalConvoMessages = (convo_id) => http.get(`convos/internal/messages/${convo_id}`);

  addInternalMessage = (convo_id, message) => axios.post(process.env.VUE_APP_API_URL +`/api/convos/internal/${convo_id}/messages`, message,{
  withCredentials: true
});
  
  getConvoMediaUrl = (convo_message_id, media_id) => http.defaults.baseURL + `/convos/internal/messages/${convo_message_id}/media/${media_id}`;

  updateInternalLastReadTime = (convo_id) => http.put(`/convos/internal/${convo_id}/participants`);

  updateInternalMentionStatus = (convo_id, convo_message_id, params) =>
    http.put(`/convos/internal/${convo_id}/messages/${convo_message_id}/mentions`, params);

  // convo_reminder_id: optional — targets a specific reminder row (e.g. someone
  // else's) instead of the caller's own, per reminderWhere in convo.controller.js
  deleteInternalConvoReminder = (convo_id, convo_reminder_id) => http.delete(`/convos/internal/${convo_id}/reminder`, { data: { convo_reminder_id } });

  addInternalReminder = (data) => http.post("/convos/internal/reminder", data);

  updateInternalReminder = (data) => http.put("/convos/internal/reminder", data);

  getDueReminderContacts = () => http.get(`/convos/internal/due-reminders`);

  getDueRemindersForConversation = (conversation_id) => http.get(`/convos/internal/due-reminders/${conversation_id}`);

  // AI agents
  getOrCreateClaimsAssistantConvo = () => http.get('/ai/claims-assistant-convo');

  getOdStats = (tag_id) => http.get(`/ai/od_stat/${tag_id}`);

  getFDStats = () => http.get(`/ai/fd_stat`);

  callSchedulingAI = (message) => http.post(`/ai/scheduling`, message);

  getPlivoCostAI = () => http.get(`/ai/plivocost`);

  addConvoNotes =(message_id,data) => http.post(`/convos/convo_notes/messages/${message_id}`,data);

  //thread convos for ./conversation path intrenal convos

  getThreadConvos =(convo_id) => http.get(`/convos/thread/parent_convo_id/${convo_id}`);

}

export default new ConvoService();
